import type { ReactNode } from "react";
import { ReviewerAvatar } from "./reviewer-avatar";
import { formatReviewDate } from "./format-review-date";

interface FooterReview {
  date?: string;
  location?: string;
  name: string;
  profileImageUrl?: string;
}

interface GridReviewFooterProps {
  review: FooterReview;
  showDates: "yes" | "no";
}

const shownDate = (review: FooterReview, showDates: "yes" | "no"): string | undefined => {
    if (showDates === "yes") {
      return formatReviewDate(review.date);
    }
    return undefined;
  },

  // The reviewer, with their town and the date, along the bottom of a grid card.
  GridReviewFooter = ({ review, showDates }: GridReviewFooterProps): ReactNode => {
    const details = [review.location, shownDate(review, showDates)].filter(Boolean).join(" · ");
    return (
      <div className="jobsite:border-t jobsite:border-border/50 jobsite:pt-5">
        <div className="jobsite:flex jobsite:items-center jobsite:gap-3">
          <ReviewerAvatar review={review} />
          <div className="jobsite:min-w-0">
            <div className=" jobsite:text-base jobsite:font-heading jobsite:text-card-foreground jobsite:truncate">
              {review.name}
            </div>
            {details !== "" && (
              <div className="jobsite:mt-0.5 jobsite:text-sm jobsite:text-muted-foreground jobsite:truncate">
                {details}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

export { GridReviewFooter };
